module.exports = __webpack_public_path__ + "static/media/features-pdf-import.e8d1c86b.png";